import fetch from '@/utils/fetch';

/************ dict **************************/

//
export function getDictfindByType(data) {
    return fetch({
        url: '/contract/config/dict/findByType',
        method: 'get',
        params: data
    });

}

//模糊查询


export function queryByTypeAndValue(data) {
    return fetch({
        url: '/contract/config/dict/queryByTypeAndValue',
        method: 'get',
        params: data
    });

}


// 保存更新
export function saveDict(data) {
  return fetch({
    url: '/contract/config/dict/saveDict',
    method: 'post',
    data
  });
}


// 增加
export function insertDict(data) {
    return fetch({
        url: '/contract/config/dict/newDict',
        method: 'post',
        data
    });
}


// 删
export function delDict(dictId ) {
  return fetch({
    url: '/contract/config/dict/delDict',
    method: 'get',
    params: {dictId }
  });
}


export function getDictData( refthis,typeString ,dataparam) {
    //获取组织服务源数据

    getDictfindByType( {type:typeString}).then(response => {

        if (response.code == 'H0000' && response.data) {

            eval( dataparam );

        } else {
            refthis.$message.error(response.data.msg);
        }
    }).catch(error => {
        console.log(error.data);
    });
}




// WEBPACK FOOTER //
// ./src/api/taxManager.js